const browser =
  (navigator.languages && navigator.languages[0]) ||
  navigator.language ||
  navigator.userLanguage

const userLang = browser.substr(0, 2)

export default userLang
